import { connect } from 'react-redux';

import { isSearchCompleteSelector } from 'src/routes/SearchPage/searchStatus/selectors';
import { SubscribeMobileMountains } from './SubscribeMobileMountains';

const mapStateToProps = (state) => ({
  isLoaded: isSearchCompleteSelector(state) as boolean,
});

export default connect(mapStateToProps)(SubscribeMobileMountains);
